import cookies from 'js-cookie';
import jwtDecode from 'jwt-decode';
import React from 'react';
import { cookieNames } from '~constants';
import MyProfile from './my-profile';

const Account = () => {
  const info = jwtDecode(cookies.get(cookieNames.token));
  return (
    <div>
      <MyProfile userUuid={info?.uuid} />
    </div>
  );
};

export default Account;
